import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { USER_FEATURE } from '@core/user/store/user.states';
import { userReducer } from '@core/user/store/user.reducer';
import { UserEffects } from '@core/user/store/user.effect';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(USER_FEATURE, userReducer), EffectsModule.forFeature([UserEffects])],
})
export class UserStoreModule {}
